import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_recurring_coupon_hdr_RowClass} from '../../../dbschema/bl_fi_mst_recurring_coupon_hdr';

export class RecurringCouponHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_recurring_coupon_hdr: bl_fi_mst_recurring_coupon_hdr_RowClass = new bl_fi_mst_recurring_coupon_hdr_RowClass();
}
